import client from '@/http'
import dayjs from "dayjs";

const load = (context, params) => {
  client.get(
    `page-items/${params.path}/${params.edit}`
  ).then(
    (res) => {
      context.commit('SET_ITEM', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const create = (context, params) => {
  context.commit('SET_LOADING')

  client.post(
    'page-items',
    params
  ).then(
    (res) => {
      context.commit('SET_ITEM', res.data)
      context.commit('SET_SUCCESS')
      setTimeout(() => context.commit('RESET_STATUS'), 1500)
    }
  ).catch(
    (err) => {
      console.error(err)
      context.commit('SET_ERROR')
    }
  )
}

const update = (context, params) => {
  context.commit('SET_LOADING')

  client.put(
    `page-items/${params.id}`,
    params
  ).then(
    () => {
      context.commit('SET_SUCCESS')
      setTimeout(() => context.commit('RESET_STATUS'), 1500)
    }
  ).catch(
    (err) => {
      console.error(err)
      context.commit('SET_ERROR')
    }
  )
}

const remove = (context, ids) => {
  client.delete(
    `page-items/${ids}`
  ).then(
    () => {
      context.commit('pages/REMOVE_ORPHAN', ids, { root: true })
      context.commit('RESET_REMOVABLES')
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const download = (context, page) => {
  const params = {
    pageId: page.id,
    bundleId: page.bundle.id
  }

  client.post(
    'page-items/download', params,
    {
      responseType: 'blob'
    }).then(
    res => {
      const timestamp = dayjs().format('DD-MM-YYYY_HH-mm-ss')
      const fileURL = window.URL.createObjectURL(new Blob([res.data]))
      const fURL = document.createElement('a')
      const fileName = `${page.bundle.name}-${page.name}-${timestamp}.xlsx`.toLowerCase()

      fURL.href = fileURL
      fURL.setAttribute('download', fileName)
      document.body.appendChild(fURL)

      fURL.click()
    }
  )
}

export default {
  load,
  create,
  update,
  remove,
  download
}
